import { render, staticRenderFns } from "./ResumenGastos.vue?vue&type=template&id=6818f8b9&"
import script from "./ResumenGastos.vue?vue&type=script&lang=js&"
export * from "./ResumenGastos.vue?vue&type=script&lang=js&"
import style0 from "./ResumenGastos.vue?vue&type=style&index=0&id=6818f8b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports